import * as types from "./profileActionTypes";

const stateObject = {
  isLoading: false,
  isSuccess: false,
  error: null,
  isError: false
};

const initialState = {
  updatePhoneSendState: { ...stateObject, payload: {} },
  updatePhoneVerifyState: { ...stateObject, payload: {} },
  deactivateSendState: { ...stateObject, payload: {} },
  deactivateVerifyState: { ...stateObject, payload: {} },
  jobPostEligibility: {
    ...stateObject,
    payload: {
      can_post: true,
      type: "FREE_EXHAUSTED"
    }
  },
  isCompNameFromSuggestor: false
};

export default function profileReducer(state = initialState, action) {
  switch (action.type) {
    case types.UPDATE_PHONE_SEND_OTP_LOADING:
      return {
        ...state,
        updatePhoneSendState: {
          ...state.updatePhoneSendState,
          isLoading: true
        }
      };
    case types.UPDATE_PHONE_SEND_OTP_SUCCESS:
      return {
        ...state,
        updatePhoneSendState: {
          ...state.updatePhoneSendState,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload
        }
      };
    case types.UPDATE_PHONE_SEND_OTP_FAILURE:
      return {
        ...state,
        updatePhoneSendState: {
          ...state.updatePhoneSendState,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        }
      };

    case types.UPDATE_PHONE_VERIFY_OTP_LOADING:
      return {
        ...state,
        updatePhoneVerifyState: {
          ...state.updatePhoneVerifyState,
          isLoading: true
        }
      };
    case types.UPDATE_PHONE_VERIFY_OTP_SUCCESS:
      return {
        ...state,
        updatePhoneVerifyState: {
          ...state.updatePhoneVerifyState,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload
        }
      };
    case types.UPDATE_PHONE_VERIFY_OTP_FAILURE:
      return {
        ...state,
        updatePhoneVerifyState: {
          ...state.updatePhoneVerifyState,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        }
      };

    case types.DEACTIVATE_SEND_OTP_LOADING:
      return {
        ...state,
        deactivateSendState: {
          ...state.deactivateSendState,
          isLoading: true
        }
      };
    case types.DEACTIVATE_SEND_OTP_SUCCESS:
      return {
        ...state,
        deactivateSendState: {
          ...state.deactivateSendState,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload
        }
      };
    case types.DEACTIVATE_SEND_OTP_FAILURE:
      return {
        ...state,
        deactivateSendState: {
          ...state.deactivateSendState,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        }
      };

    case types.DEACTIVATE_VERIFY_OTP_LOADING:
      return {
        ...state,
        deactivateVerifyState: {
          ...state.deactivateVerifyState,
          isLoading: true
        }
      };
    case types.DEACTIVATE_VERIFY_OTP_SUCCESS:
      return {
        ...state,
        deactivateVerifyState: {
          ...state.deactivateVerifyState,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload
        }
      };
    case types.DEACTIVATE_VERIFY_OTP_FAILURE:
      return {
        ...state,
        deactivateVerifyState: {
          ...state.deactivateVerifyState,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        }
      };
    case types.JOB_POST_ELIGIBILITY_SUCCESS:
      return {
        ...state,
        jobPostEligibility: {
          ...state.jobPostEligibility,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: {
            ...state.jobPostEligibility.payload,
            ...action.payload
          }
        }
      };
    case types.JOB_POST_ELIGIBILITY_FAILURE:
      return {
        ...state,
        jobPostEligibility: {
          ...state.jobPostEligibility,
          isLoading: false,
          isSuccess: false,
          error: action.payload
        }
      };

    case types.IS_COMP_NAME_FROM_SUGGESTOR:
      return {
        ...state,
        isCompNameFromSuggestor: action.payload
      };

    default:
      return state;
  }
}
